export const GET_QUOTE_BY_ID = "GET_QUOTE_BY_ID";
export const NEW_QUOTE = "NEW_QUOTE";
export const CONVERT_QUOTE = "CONVERT_QUOTE";
export const GET_COST_BREAKDOWN = "GET_COST_BREAKDOWN";
export const GET_MARKET_COSTS = "GET_MARKET_COSTS";
export const GET_COMMODITY_DESCRIPTIONS = "GET_COMMODITY_DESCRIPTIONS";
export const GET_QUOTES_V3 = "GET_QUOTES_V3";
